import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Badge,
} from "reactstrap";

const RecentSyncLogs = ({
  logs = [],
}) => {

  const getStatusColor = (
    status
  ) => {

    switch (
      status?.toUpperCase()
    ) {

      case "SUCCESS":
        return "success";

      case "PARTIAL SUCCESS":
        return "warning";

      case "PENDING":
        return "info";

      case "FAILED":
        return "danger";

      default:
        return "secondary";
    }
  };

  return (
    <Col xl={12}>
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <h4 className="card-title mb-0">
            Recent Sync Logs
          </h4>

          <Badge color="primary">
            {logs.length} Logs
          </Badge>
        </CardHeader>

        <CardBody>

          {logs.length === 0 ? (

            <div className="text-center text-muted py-5">
              No Sync Logs Found
            </div>

          ) : (

            <div className="table-responsive">

              <table className="table table-bordered table-hover align-middle">

                <thead className="table-light">
                  <tr>

                    <th>
                      Channel
                    </th>

                    <th>
                      Sync Type
                    </th>

                    <th>
                      Status
                    </th>

                    <th>
                      Response Time
                    </th>

                    <th>
                      Synced At
                    </th>

                    <th>
                      Error
                    </th>

                  </tr>
                </thead>

                <tbody>

                  {logs
                    .sort(
                      (
                        a,
                        b
                      ) =>
                        new Date(
                          b.createdAt
                        ) -
                        new Date(
                          a.createdAt
                        )
                    )
                    .slice(
                      0,
                      10
                    )
                    .map(
                      log => (
                        <tr
                          key={
                            log._id
                          }
                        >

                          <td>
                            <strong>
                              {
                                log.channelManager
                              }
                            </strong>
                          </td>

                          <td>
                            {
                              log.syncType
                            }
                          </td>

                          <td>
                            <Badge
                              color={getStatusColor(
                                log.status
                              )}
                            >
                              {
                                log.status
                              }
                            </Badge>
                          </td>

                          <td>
                            {
                              log.responseTime ||
                              0
                            }
                            ms
                          </td>

                          <td>
                            {log.syncedAt
                              ? new Date(
                                  log.syncedAt
                                ).toLocaleString()
                              : "-"}
                          </td>

                          <td>

                            {log.errorMessage ? (

                              <span className="text-danger">
                                {
                                  log.errorMessage
                                }
                              </span>

                            ) : (

                              <span className="text-success">
                                None
                              </span>

                            )}

                          </td>

                        </tr>
                      )
                    )}

                </tbody>

              </table>

            </div>

          )}

        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentSyncLogs;